// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__7dsEe","col":"styles_col__3TzIK","fulfillmentStatus":"styles_fulfillmentStatus__3dCWn","emailCol":"styles_emailCol__37wvj"};